/* @flow */
import { cropableImageModalActionMaker } from '@website/components/ActionMakers'
import {
  addBlock,
  changeTitle,
  changeParagraph,
  changeTitleAlignment,
  changeParagraphAlignment
} from '@website/components/CommonActions'

export default dispatcher => {
  const changeStepData = (data: string, idx: number, keyInStore: string) => {
    dispatcher({
      type: 'CHANGE_STEP_DATA',
      value: { data, idx, keyInStore }
    })
  }
  const changeBlockTitle = (title: string, idx: number) => {
    dispatcher(changeStepData(title, idx, 'stepTitle'))
  }

  const changeBlockParagraph = (paragraph: string, idx: number) => {
    dispatcher(changeStepData(paragraph, idx, 'stepDescription'))
  }

  const changeBlockParagraphAlignment = (alignment: string, idx: number) => {
    dispatcher({
      type: 'CHANGE_BLOCK_PARAGRAPH_ALIGNMENT',
      value: { alignment, idx }
    })
  }

  const changeBlockTitleAlignment = (alignment: string, idx: number) => {
    dispatcher({
      type: 'CHANGE_BLOCK_TITLE_ALIGNMENT',
      value: { alignment, idx }
    })
  }

  const _changeTitle = (title: string) => {
    dispatcher(changeTitle(title))
  }

  const _changeParagraph = (paragraph: string) => {
    dispatcher(changeParagraph(paragraph))
  }

  const _changeTitleAlignment = alignment => {
    dispatcher(changeTitleAlignment(alignment))
  }

  const _changeParagraphAlignment = alignment => {
    dispatcher(changeParagraphAlignment(alignment))
  }

  return {
    addBlock,
    changeTitle: _changeTitle,
    changeParagraph: _changeParagraph,
    changeTitleAlignment: _changeTitleAlignment,
    changeParagraphAlignment: _changeParagraphAlignment,
    changeBlockTitle,
    changeBlockParagraph,
    changeBlockTitleAlignment,
    changeBlockParagraphAlignment,
    imageActions: (idx, imageUrl) =>
      cropableImageModalActionMaker(dispatcher)({
        keyForSizes: 'steps5',
        showRemove: false,
        additionalArgs: { idx },
        imageUrl
      })
  }
}
